
/*
  Author: Vinod
  Date: 19/03/2020
  Issue: In Multi select drop down,Sub criteria able to type invalid text and able to create.
  Search_string: PL_2959
*/

<template>
  <div>
    <div class="input-label">{{label}}</div>
    <div class="custom-select">
      <v-select
        :name="name"
        :label="labelText"
        v-bind:disabled="disable"
        v-model="selected"
        :data-vv-name="name"
        :placeholder="placeholder"
        :options="options"
        :value="value"
        ref="theSelect"
        @input="onSelected"
        @search:blur="$emit('blur'); clearSearch()"
        :multiple="multiple"
        :class="{'errorr': classname}"
        v-validate="validations"
      ></v-select>
    </div>
    <span class="errorMessage" v-show="classname">&nbsp;{{errormsg}}</span>
  </div>
</template>
<script>
import VSelect from "vue-select";

export default {
  name: "TlSelect",
  props: {
    label: String,
    labelText: String,
    options: Array,
    value: String | Object,
    name: String,
    classname: Boolean,
    placeholder: String,
    multiple: {
      type: Boolean,
      default: false
    },
    validations: {
      type: String
    },
    errormsg: String,
    disable: Boolean
  },
  data() {
    return {
      selected: this.value
    };
  },
  watch: {
    value: function(v) {
      this.selected = v;
    }
  },
  methods: {
    onSelected: function(value) {
      this.$emit("change", value);
      return value;
    },
    // PL_2959
    clearSearch() {
      this.$refs.theSelect.search = "";
    }
  },
  components: {
    VSelect
  }
};
</script>
<style lang="scss">
.vs__selected {
  color: #444444;
}
.custom-width-new {
  .custom-select {
    .vs--searchable .vs__dropdown-toggle {
      height: 35px;
    }
  }
}
</style>

<style lang="scss" scoped>
// .input-label{
// color:#000000;
// font-size: 14px;
// width: 224px;
// height: 18px;
// font-family: Montserrat;
// }

.tl-select-dropdown {
  margin-bottom: 15px;
}
.form-group {
  /* Already formgroup having margin bottom 15px */
  .tl-select-dropdown {
    margin-bottom: 0px;
  }
}

.errorMessage {
  padding-top: 5px !important;
  display: inline-block;
  padding-bottom: 10px;
}
.errorr {
  border-radius: 4px;
}
.vs__dropdown-menu {
  min-width: auto;
}
.vs__dropdown-toggle {
  max-width: 300px;
  // height: 35px !important;
  height: auto !important;
  padding: 0;
}
</style>
